import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Bookmarks.Bookmarks = {
    bookmarks: {},
    bookmarkButtons: {},
    isLoading: false,
    filter: "",
    initialized: false,
    workspaceId: 0,
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: Bookmarks.Bookmarks,
        props: Action,
    ) => Bookmarks.Bookmarks
} = {
    [actions.SET_INITIALIZED]: (state): Bookmarks.Bookmarks => ({
        ...state,
        initialized: true,
    }),

    [actions.SET_WORKSPACE_ID]: (
        state,
        { workspaceId }: actions.SetWorkspaceId,
    ): Bookmarks.Bookmarks => ({ ...state, workspaceId }),

    [actions.REQUEST_BOOKMARKS]: (state): Bookmarks.Bookmarks => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_BOOKMARKS]: (
        state,
        {
            bookmarks: bookmarksArray,
        }: actions.BookmarkButtonIdWithBookmarkIdActions,
    ): Bookmarks.Bookmarks => {
        const bookmarks: Record<string, Models.Bookmark> = {}
        bookmarksArray.forEach((bookmark) => {
            if (!!bookmark.bookmarkId) {
                bookmarks[bookmark.bookmarkId.toString()] = bookmark
            }
        })

        return {
            ...state,
            bookmarks,
            isLoading: false,
        }
    },

    [actions.FILTER_BOOKMARKS]: (
        state,
        { filter }: actions.FilterBookmarks,
    ): Bookmarks.Bookmarks => ({ ...state, filter }),

    [actions.INITIALIZE_BOOKMARK_BUTTON]: (
        state,
        {
            bookmarkButtonId,
            bookmarkId,
            parentItemId,
            resourceId,
            resourceType,
            workspaceId,
            url,
        }: actions.InitializeBookmarkButton,
    ): Bookmarks.Bookmarks => ({
        ...state,
        bookmarkButtons: {
            ...state.bookmarkButtons,
            [bookmarkButtonId]: {
                bookmarkButtonId,
                bookmarkId,
                isLoading: true,
                parentItemId,
                resourceId,
                resourceType,
                workspaceId,
                url,
            },
        },
    }),

    [actions.REMOVE_BOOKMARK_BUTTON]: (
        state,
        { bookmarkButtonId }: actions.BookmarkButtonIdAction,
    ): Bookmarks.Bookmarks => {
        const bookmarkButtons: Record<string, Bookmarks.BookmarkButton> = {
            ...state.bookmarkButtons,
        }
        delete bookmarkButtons[bookmarkButtonId]
        return { ...state, bookmarkButtons }
    },

    [actions.RECEIVE_BOOKMARK_BUTTON_BOOKMARK_ID]: (
        state,
        {
            bookmarkButtonId,
            bookmarkId,
            isLoading,
        }: actions.ReceiveBookmarkButtonBookmarkIdAction,
    ): Bookmarks.Bookmarks => {
        const bookmarkButtons = {
            ...state.bookmarkButtons,
            [bookmarkButtonId]: {
                ...state.bookmarkButtons[bookmarkButtonId],
                bookmarkId,
                isLoading,
            },
        }
        return { ...state, bookmarkButtons }
    },

    [actions.ADD_BOOKMARK]: (
        state,
        { bookmarkButton }: actions.BookmarkButtonAction,
    ): Bookmarks.Bookmarks => {
        const { bookmarkButtonId } = bookmarkButton

        const bookmarkButtons = {
            ...state.bookmarkButtons,
            [bookmarkButtonId]: {
                ...state.bookmarkButtons[bookmarkButtonId],
                isLoading: true,
            },
        }
        return { ...state, bookmarkButtons }
    },

    [actions.UNBOOKMARK]: (
        state,
        { bookmarkButton }: actions.BookmarkButtonAction,
    ): Bookmarks.Bookmarks => {
        const { bookmarkButtonId } = bookmarkButton

        const bookmarkButtons = {
            ...state.bookmarkButtons,
            [bookmarkButtonId]: {
                ...state.bookmarkButtons[bookmarkButtonId],
                isLoading: true,
            },
        }
        return { ...state, bookmarkButtons }
    },

    [actions.RECEIVE_BOOKMARK]: (
        state,
        { bookmark }: actions.BookmarkAction,
    ): Bookmarks.Bookmarks => ({
        ...state,
        bookmarks: {
            ...state.bookmarks,
            [bookmark.bookmarkId.toString()]: bookmark,
        },
    }),

    [actions.RECEIVE_REMOVE_BOOKMARK]: (
        state,
        { bookmarkId }: actions.BookmarkIdAction,
    ): Bookmarks.Bookmarks => {
        const bookmarks: Record<string, Models.Bookmark> = {
            ...state.bookmarks,
        }
        delete bookmarks[bookmarkId]
        return { ...state, bookmarks }
    },
}

export default function reducer(
    state: Bookmarks.Bookmarks = initialState,
    action: Action,
): Bookmarks.Bookmarks {
    const handler: (
        state: Bookmarks.Bookmarks,
        action: Action,
    ) => Bookmarks.Bookmarks = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
